import React, { useState, useEffect } from 'react';

const FirebaseErrorHandler = () => {
  const [firebaseError, setFirebaseError] = useState(null);

  useEffect(() => {
    // Check for Firebase initialization errors
    const checkFirebaseError = () => {
      // Commented out to prevent infinite log spam:
      // console.log('🔍 Checking for Firebase errors...', window.FIREBASE_INIT_ERROR);
      if (window.FIREBASE_INIT_ERROR) {
        console.log('🚨 Firebase error detected:', window.FIREBASE_INIT_ERROR);
        setFirebaseError(window.FIREBASE_INIT_ERROR);
      }
    };

    // Check immediately
    checkFirebaseError();

    // Also check after a short delay in case the error occurs during initialization
    const timer = setTimeout(checkFirebaseError, 2000);
    
    // Check periodically for errors that might be set later
    const interval = setInterval(checkFirebaseError, 3000);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, []);

  if (!firebaseError) return null;

  const handleRetry = () => {
    // Clear the error and reload the page
    window.FIREBASE_INIT_ERROR = null;
    window.location.reload();
  };

  const handleGoToLocalhost = () => {
    // Try to redirect to localhost version
    const currentPath = window.location.pathname + window.location.search;
    window.location.href = `http://localhost:3401${currentPath}`;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Connection Problem
          </h3>
          <p className="text-gray-600 text-sm mb-4">
            {firebaseError.message}
          </p>
          {firebaseError.isNetworkIssue && (
            <p className="text-sm text-blue-600 bg-blue-50 p-3 rounded-lg mb-4">
              💡 {firebaseError.suggestion}
            </p>
          )}
        </div>
        
        <div className="space-y-3">
          <button
            onClick={handleRetry}
            className="w-full bg-bela-600 hover:bg-bela-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
          >
            Try Again
          </button>
          
          <button
            onClick={() => setFirebaseError(null)}
            className="w-full text-gray-500 hover:text-gray-700 text-sm"
          >
            Continue Anyway (Limited Features)
          </button>
        </div>
        
        {process.env.NODE_ENV === 'development' && (
          <details className="mt-4">
            <summary className="cursor-pointer text-xs text-gray-400 hover:text-gray-600">
              Technical Details
            </summary>
            <div className="mt-2 p-2 bg-gray-50 rounded text-xs font-mono text-gray-500 max-h-32 overflow-auto">
              {firebaseError.originalError?.toString()}
            </div>
          </details>
        )}
      </div>
    </div>
  );
};

export default FirebaseErrorHandler;
